// extracted by mini-css-extract-plugin
export default {"dropdown":"styles_dropdown__cVHIW","status":"styles_status__gtj0U","modal":"styles_modal__JJLkZ","note":"styles_note__RzAO5","rot":"styles_rot__ivXMH"};